import personTranslations from "./personTranslations";
import { prosecutionTranslations } from "./prosecutionTranslations";
import opposingPartyLegalEntityTranslations from "./opposingPartyLegalEntityTranslations";
import contactTranslations from "./contactTranslations";
import addressTranslations from "./addressTranslations";
import { objectivesLawFirmValues } from "./objectivesLawFirmTranslations";
import contractClaimTranslations from "./contractClaimTranslations";
import organizationEmailTranslations from "./organizationEmailTranslations";
import organizationTranslation from "./organizationTranslation";
import litigationCaseTranslations from "./litigationCaseTranslations.ts";

const rentalContractTranslations = {
  ...contractClaimTranslations,
  label: "Mietvertrag",
  personalTextMessage: {
    label: "Fragen und Anmerkungen zum Fall",
  },
  endOfContractDate: {
    label: "Datum Vertragsende",
  },
  reasonForDispute: {
    label: "Problem der Mandantschaft",
    values: {
      other: "Anderes Anliegen",
      deposit: "Kaution",
      rentIncrease: "Mieterhöhung",
      utilitiesStatement: "Nebenkostenabrechnung",
      illegalContractClause: "Widerrechtliche Vertragsklausel",
      landlordHasCancelled: "Kündigung",
      housingDeficiencies: "Mietmängel",
      rentReduction: "Mietminderung",
      rentLate: "Mietverzug",
      terminationRejection: "Abgelehnte Kündigung",
      depositPayout: "Kautionserstattung",
    },
  },
  rentReductionPercentage: {
    label: "Minderung in %",
  },
  housingDeficienciesDescriptionClient: {
    label: "Mängelbeschreibung Mandantschaft",
  },
  housingDeficienciesDescriptionLawFirm: {
    label: "Mängelbeschreibung Kanzlei",
  },
  previousBasicRent: {
    label: "Höhe vereinbarte Kaltmiete",
  },
  previousRentIncludingHeating: {
    label: "Höhe vereinbarte Warmmiete",
  },
  futureBasicRent: {
    label: "Höhe der neuen Kaltmiete",
  },
  futureRentIncludingHeating: {
    label: "Höhe der neuen Warmmiete",
  },
  cancellationReceivedDate: {
    label: "Eingang der Kündigung",
  },
  rentalContractStartDate: {
    label: "Start Mietverhältnis",
  },
  rentalContractEndDate: {
    label: "Ende Mietverhältnis",
  },
  depositAmount: {
    label: "Höhe der Kaution",
  },
  additionalClaimText: {
    label: "Zusatztext Forderung",
  },
  additionalIssueDescriptionText: {
    label: "Zusatztext Schilderung Sachverhalt",
  },
  buyerPaidDate: {
    label: "Zahlungsdatum Käufer",
  },
  buyerPaidStatus: {
    label: "Bezahlstatus Käufer",
    values: {
      fully: "vollständig",
      partially: "teilweise",
      none: "noch gar nicht",
    },
  },
  responsibleProsecution: prosecutionTranslations,
  contractNumber: {
    label: "Vertragsnummer",
  },
  contractDate: {
    label: "Vertragsabschluss am",
  },
  opposingPartyType: {
    label: "Vermieter ist",
    values: {
      opposingPartyLegalEntity: "Unternehmen",
      opposingPartyPerson: "Privatperson",
    },
  },
  contractualPartnerPerson: personTranslations,
  contractualPartnerLegalEntity: {
    organizationEmail: organizationEmailTranslations,
    organization: {
      label: "Gegenseite",
      ...opposingPartyLegalEntityTranslations,
    },
  },
  propertyAddress: addressTranslations,
  propertyManager: {
    organizationEmail: organizationEmailTranslations,
    organization: {
      label: "Hausverwaltung",
      ...organizationTranslation,
      legalName: {
        label: "Name",
      },
      ...contactTranslations,
      address: addressTranslations,
    },
  },
  propertyManagerReference: {
    label: "Aktenzeichen",
  },
  goodsOrServiceProvidedStatus: {
    label: "Status Leistungserbringung/Lieferung",
    values: {
      fully: "vollständig",
      partially: "teilweise",
      none: "noch gar nicht",
    },
  },
  paymentOrderDate: {
    label: "Datum des Mahnbescheids",
  },
  enforcementOrderDate: {
    label: "Datum des Vollstreckungsbescheids",
  },
  overdueFees: {
    label: "Mahngebühren",
  },
  subjectOfDispute: {
    label: "Forderung",
    values: {
      money: "Geld",
      goods: "Ware oder Leistung",
      moneyAndGoods: "Geld und Leistung",
      other: "Sonstiges",
    },
    enforceClaim: {
      label: "Forderung Mandant",
      values: {
        money: "Geld",
        goods: "Ware oder Leistung",
        moneyAndGoods: "Geld und Leistung",
        other: "Sonstiges",
      },
    },
    defendClaim: {
      label: "Forderung Gegenseite",
      values: {
        money: "Geld",
        goods: "Ware oder Leistung",
        moneyAndGoods: "Geld und Leistung",
        other: "Sonstiges",
      },
    },
  },
  contractPartyType: {
    label: "Rolle Mandantschaft",
    values: {
      tenant: "Mieter",
      landlord: "Vermieter",
    },
  },
  objectiveLawFirm: {
    label: "Zielsetzung Kanzlei",
    values: {
      ...objectivesLawFirmValues,
      paymentRequestDeposit: "Zahlungsaufforderung Kaution",
      paymentRequestRent: "Zahlungsaufforderung Miete",
      paymentRequestServiceCharges: "Zahlungsaufforderung Nebenkosten",
      rejectionDepositRefund: "Zurückweisung Kautionsverlangen",
      rejectionRentDecreaseNoDefects: "Widerspruch Mietminderung - Zurückweisung",
      rejectionRentDecreaseNoEvidence: "Widerspruch Mietminderung - Prüfung",
      rentIncrease: "Durchsetzung Mieterhöhung",
      rentReduction: "Mietminderung",
      terminationNotice: "Kündigungserklärung",
    },
  },
  objectiveLawFirmSecondary: {
    label: "Sekundäre Zielsetzung Kanzlei",
    values: {
      ...objectivesLawFirmValues,
      paymentRequestDeposit: "Zahlungsaufforderung Kaution",
      paymentRequestRent: "Zahlungsaufforderung Miete",
      paymentRequestServiceCharges: "Zahlungsaufforderung Nebenkosten",
      rejectionDepositRefund: "Zurückweisung Kautionsverlangen",
      rejectionRentDecreaseNoDefects: "Widerspruch Mietminderung - Zurückweisung",
      rejectionRentDecreaseNoEvidence: "Widerspruch Mietminderung - Prüfung",
      rentIncrease: "Durchsetzung Mieterhöhung",
      rentReduction: "Mietminderung",
      terminationNotice: "Kündigungserklärung",
    },
  },
  objectiveLawFirmTertiary: {
    label: "Tertiäre Zielsetzung Kanzlei",
    values: {
      ...objectivesLawFirmValues,
      paymentRequestDeposit: "Zahlungsaufforderung Kaution",
      paymentRequestRent: "Zahlungsaufforderung Miete",
      paymentRequestServiceCharges: "Zahlungsaufforderung Nebenkosten",
      rejectionDepositRefund: "Zurückweisung Kautionsverlangen",
      rejectionRentDecreaseNoDefects: "Widerspruch Mietminderung - Zurückweisung",
      rejectionRentDecreaseNoEvidence: "Widerspruch Mietminderung - Prüfung",
      rentIncrease: "Durchsetzung Mieterhöhung",
      rentReduction: "Mietminderung",
      terminationNotice: "Kündigungserklärung",
    },
  },
  advisoryAppointment: {
    label: "Beratungsgespräch",
  },
  contractWasTakenOverByOpposingParty: {
    label: "Aktueller Vermieter im Vertrag",
  },
  courtPostalCodeOptions: {
    ...litigationCaseTranslations.courtPostalCodeOptions,
    property: "Mietsache",
  },
};

export default rentalContractTranslations;
